import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
// import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { AdsByBingColumn as AdsByBingColumnConfig } from '@bingads-webui-campaign/ads-data';
import adsByBingTemplate from './ads-by-bing.pug';

export class AdsByBingColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_AdsByBing');

    super({
      ...AdsByBingColumnConfig,
      title,
      sortable: 'AdsByBing',
      type: 'boolean',
      helpId: 'pop_BA_Recommendations_AutomatedAds',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
  }

  pickProperty(item) {
    // return empty for total rows
    if (item.AdsByBing != null) {
      return item.AdsByBing ? this.i18n.getString('AdsByBing_True')
        : this.i18n.getString('AdsByBing_False');
    }
    return '';
  }

  template({ value }) {
    return adsByBingTemplate({ value });
  }
}
